export default __webpack_public_path__ + "static/play-blue-0475fb290f4f975675e9726cc3bfb570.png";